import { Injectable } from '@angular/core';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import { Router } from '@angular/router';
import { AuthService } from '../../auth';
import {
  FireRelationshipCategorySuccess,
  RelationshipCategoryActionToggleLoading,
  RelationshipCategoryActionTypes,
  RelationshipCategoryDeleted,
  RelationshipCategoryOnServerDeleted,
  RelationshipCategoryPageLoaded,
  RelationshipCategoryPageRequested,
  RelationshipCategoryPageToggleLoading,
  ThrowRelationshipCategoryError,
} from '../_actions/relationship-category.actions';
import { RelationshipCategoryService } from '../_services/relationship-category.service';

@Injectable()
export class RelationshipCategoryEffects {
  showPageLoadingDistpatcher = new RelationshipCategoryPageToggleLoading({ isLoading: true });
  hidePageLoadingDistpatcher = new RelationshipCategoryPageToggleLoading({ isLoading: false });
  showActionLoadingDistpatcher = new RelationshipCategoryActionToggleLoading({ isLoading: true });
  hideActionLoadingDistpatcher = new RelationshipCategoryActionToggleLoading({ isLoading: false });

  @Effect()
  loadRelationshipCategoryPage$ = this.actions$.pipe(
    ofType<RelationshipCategoryPageRequested>(
      RelationshipCategoryActionTypes.RelationshipCategoryPageRequested,
    ),
    mergeMap(({ payload }) => {
      this.store.dispatch(this.showPageLoadingDistpatcher);
      return this.relationshipCategory.findRelationshipCategory(payload.page).pipe(
        catchError((error) => {
          return of([error]);
        }),
        map((result) => {
          return new RelationshipCategoryPageLoaded({
            relationshipCategory: result.data,
            totalCount: result.count,
            page: result.page,
          });
        }),
      );
    }),
  );

  @Effect()
  deleteRelationshipCategory$ = this.actions$.pipe(
    ofType<RelationshipCategoryOnServerDeleted>(
      RelationshipCategoryActionTypes.RelationshipCategoryOnServerDeleted,
    ),
    mergeMap(({ payload }) => {
      this.store.dispatch(this.showActionLoadingDistpatcher);
      return this.relationshipCategory.deleteRelationshipCategory(payload.id).pipe(
        catchError((error) => {
          return of({ error });
        }),
        map((res) => {
          if (res && res.error) {
            return new ThrowRelationshipCategoryError({ error: res.error });
          } else {
            this.store.dispatch(this.hideActionLoadingDistpatcher);
            this.store.dispatch(
              new FireRelationshipCategorySuccess({
                action_type: RelationshipCategoryActionTypes.RelationshipCategoryDeleted,
              }),
            );
            return new RelationshipCategoryDeleted(payload);
          }
        }),
      );
    }),
  );

  constructor(
    private actions$: Actions,
    private relationshipCategory: RelationshipCategoryService,
    private store: Store<AppState>,
    private router: Router,
    private authService: AuthService,
  ) {}
}
